import { Action, State, StateContext } from '@ngxs/store';
import { ProOrganizerRequestEntity } from '../../domains';
import { Injectable } from '@angular/core';
import { ProOrganizerRequestsService } from '@smatchy/sdk';
import { UpdateRequest, UpdateRequestFail, UpdateRequestSuccess } from './update-request.actions';
import { catchError, tap, throwError } from 'rxjs';

export interface UpdateRequestInitialState {
  loading: boolean;
  error: unknown;
  /** null until a request is loaded, which is what the defaults below set. */
  data: ProOrganizerRequestEntity | null;
}

@State<UpdateRequestInitialState>({
  name: 'updateRequest',
  defaults: {
    loading: false,
    error: null,
    data: null,
  },
})
@Injectable()
export class UpdateRequestState {
  constructor(private service: ProOrganizerRequestsService) {}

  @Action(UpdateRequest)
  updateRequest(ctx: StateContext<UpdateRequestInitialState>, action: UpdateRequest) {
    ctx.patchState({ loading: true, error: null });
    return this.service
      .updateRequest({
        id: action.id,
        updateProOrganizerRequestDto: action.payload,
      })
      .pipe(
        tap((res) => {
          ctx.dispatch(
            new UpdateRequestSuccess((res as { data: ProOrganizerRequestEntity })?.data as ProOrganizerRequestEntity),
          );
        }),
        catchError((err: unknown) => {
          ctx.dispatch(new UpdateRequestFail(err));
          return throwError(() => err);
        }),
      );
  }
  @Action(UpdateRequestSuccess)
  updateRequestSuccess(ctx: StateContext<UpdateRequestInitialState>, action: UpdateRequestSuccess) {
    ctx.patchState({
      loading: false,
      data: action.response,
    });
  }

  @Action(UpdateRequestFail)
  updateRequestFail(ctx: StateContext<UpdateRequestInitialState>, action: UpdateRequestFail) {
    console.log('updateRequestFail', action.error);
    ctx.patchState({
      loading: false,
      error: action.error,
    });
  }
}
